import classNames from 'classnames';
import React from 'react';
import { Field } from 'react-final-form';
import { RadioButtons } from '@eika/radio-button';
import { YesNoAnswer } from '../generated-types';
const StandaloneYesNoQuestionType = _ref => {
  let {
    label,
    name,
    selected,
    validate,
    extraClass,
    overrideLabel
  } = _ref;
  const options = [{
    value: YesNoAnswer.YES,
    label: 'Ja',
    id: "".concat(name, "_id_for_yes")
  }, {
    value: YesNoAnswer.NO,
    label: 'Nei',
    id: "".concat(name, "_id_for_no")
  }];
  return /*#__PURE__*/React.createElement(Field, {
    name: name,
    validate: validate,
    render: _ref2 => {
      var _meta$error;
      let {
        input,
        meta
      } = _ref2;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('radioknobs', extraClass, 'sgw-radio-button-text')
      }, overrideLabel && /*#__PURE__*/React.createElement("span", {
        className: "sgw-radio-button-legend yes-no-radio-label-margin-override"
      }, overrideLabel), /*#__PURE__*/React.createElement(RadioButtons, {
        onChange: input.onChange,
        options: options,
        selectedOption: selected,
        horizontal: true,
        label: overrideLabel === undefined ? label : '',
        errorMessage: meta.touched && meta.error ? (_meta$error = meta.error) !== null && _meta$error !== void 0 ? _meta$error : 'Velg ett alternativ' : '',
        id: "".concat(name, "_id"),
        name: name
      }));
    }
  });
};
export default StandaloneYesNoQuestionType;